export default __webpack_public_path__ + "static/media/logo.2a6c3d95.svg";